import React from "react";
import img1 from "../../images/contact/facebook.svg";
import img2 from "../../images/contact/telegram.svg";
import img3 from "../../images/contact/twitter.svg";
import img4 from "../../images/contact/youtube.svg";
import navlogo from "../../images/contact/Marke.png";
import earnmoney from "../../images/contact/contact.png";
import "./contact.scss";
const Contact = () => {
  return (
    <>
      <div className="contactpage">
        <h1>Contact</h1>
        <div className="container">
          <div className="contact_Container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12 Address">
                <div className="Address">
                  <h3>🗺 Address</h3>
                  <p>
                    Photo booth tattooed prism, portland taiyaki hoodie neutra
                    typewriter
                  </p>
                </div>
                <div className="EMAIL">
                  <h3>💌 E-mail</h3>
                  <p>nc.example@example.com</p>
                </div>
                <div className="phone">
                  <h3>☎ Phone</h3>
                  <p>000-123-456-7890</p>
                </div>
                <div className="Socials">
                  <h3>🌏 SOCIALS</h3>
                  <ul>
                    <li>
                      <img src={img1} alt="social_img"></img>
                    </li>
                    <li>
                      <img src={img2} alt="social_img"></img>
                    </li>
                    <li>
                      <img src={img3} alt="social_img"></img>
                    </li>
                    <li>
                      <img src={img4} alt="social_img"></img>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 ContactForm">
                <form>
                  <label>Full name</label>
                  <input type="text" placeholder="Example Doe" required></input>

                  <label>Email address</label>
                  <input
                    type="text"
                    placeholder="example@example.com"
                    required
                  ></input>
                  <label>Message</label>
                  <textarea required></textarea>
                  <button className="submit">Send Message</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="earn_money">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12 leftside">
                <img src={navlogo} alt="navlogo"></img>
                <h1>
                  Earn free money <br></br>with Ciseco
                </h1>
                <p>With Ciseco you will get freeship & savings combo...</p>
                <div className="leftside_buttons">
                  <button>Savings combo</button>
                  <button>Discover more</button>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 ">
                <img src={earnmoney} alt="earn_money"></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
